import React from "react";
import { BanknoteIcon, GiftIcon, MoreHorizontalIcon, ReceiptIcon, ShieldCheckIcon, UsersRoundIcon, BoxIcon } from "lucide-react";
import { paymentTypeOptions } from "../data/payPeriods";
import { PaymentType } from "../types/payment";
const icons: Record<PaymentType, BoxIcon> = {
  payment: BanknoteIcon,
  referral: UsersRoundIcon,
  manager_override: ShieldCheckIcon,
  recruiting_bonus: GiftIcon,
  expense: ReceiptIcon,
  other: MoreHorizontalIcon
};
interface PaymentTypePickerProps {
  value: PaymentType | null;
  onChange: (value: PaymentType) => void;
}
export function PaymentTypePicker({
  value,
  onChange
}: PaymentTypePickerProps) {
  return <fieldset data-id="element-167" data-mp="10cb9jw6yxcko">
      <legend className="mb-2 flex items-baseline gap-1.5 text-xs font-medium text-ink-500" data-id="element-168" data-mp="vb4443sasph6">
        Payment Type
        <span className="text-red-500" aria-hidden="true" data-id="element-169" data-mp="3l05zkjta4m40">
          *
        </span>
        <span className="font-normal text-ink-400" data-id="element-170" data-mp="3g1cpl1d7bd8l">
          — determines which fields you'll fill in
        </span>
      </legend>
      <div role="radiogroup" aria-label="Payment Type" className="grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-171" data-mp="273vcr5lkv6i1">
        {paymentTypeOptions.map(option => {
        const Icon = icons[option.id];
        const selected = value === option.id;
        return <button key={option.id} type="button" role="radio" aria-checked={selected} onClick={() => onChange(option.id)} className={`group flex items-start gap-2.5 rounded-lg border px-3 py-3 text-left transition focus:outline-none focus:ring-4 focus:ring-brand-100 ${selected ? 'border-brand-600 bg-brand-50 ring-1 ring-brand-600' : 'border-ink-200 bg-white hover:border-brand-300 hover:bg-brand-50/40'}`} data-id="element-172" data-mp="1y5jh2p5utiiq">
              <Icon aria-hidden="true" className={`mt-0.5 h-4 w-4 shrink-0 ${selected ? 'text-brand-600' : 'text-ink-400 group-hover:text-brand-500'}`} data-id="element-173" data-mp="1fb4hoyfmrnud" />
              <span className="min-w-0" data-id="element-174" data-mp="15ft3ch84win5">
                <span className={`block text-sm font-semibold leading-5 ${selected ? 'text-brand-800' : 'text-ink-900'}`} data-id="element-175" data-mp="15h44086a9aa1">
                  {option.label}
                </span>
                <span className="mt-0.5 block text-xs leading-4 text-ink-500" data-id="element-176" data-mp="3c4bgbe2ks1j4">
                  {option.description}
                </span>
              </span>
            </button>;
      })}
      </div>
    </fieldset>;
}